/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Video_BodyInputs */

const en_us2_share_video_body = /** @type {(inputs: Share_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Under 15 seconds of your cards, 1080 × 1920, no sound. It all stays on your device.`)
};

const pt_br2_share_video_body = /** @type {(inputs: Share_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menos de 15 segundos dos seus cards, em 1080 × 1920, sem som. Fica tudo no aparelho.`)
};

const es_419_share_video_body = /** @type {(inputs: Share_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menos de 15 segundos de tus tarjetas, en 1080 × 1920, sin sonido. Todo se queda en tu dispositivo.`)
};

const pt_pt2_share_video_body = /** @type {(inputs: Share_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menos de 15 segundos dos teus cartões, em 1080 × 1920, sem som. Fica tudo no dispositivo.`)
};

const fr_fr2_share_video_body = /** @type {(inputs: Share_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moins de 15 secondes de tes cartes, en 1080 × 1920, sans son. Tout reste sur ton appareil.`)
};

const de_de2_share_video_body = /** @type {(inputs: Share_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unter 15 Sekunden deiner Karten, 1080 × 1920, ohne Ton. Alles bleibt auf deinem Gerät.`)
};

const it_it2_share_video_body = /** @type {(inputs: Share_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meno di 15 secondi delle tue card, 1080 × 1920, senza audio. Resta tutto sul tuo dispositivo.`)
};

/**
* | output |
* | --- |
* | "Under 15 seconds of your cards, 1080 × 1920, no sound. It all stays on your device." |
*
* @param {Share_Video_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_video_body = /** @type {((inputs?: Share_Video_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Video_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_video_body(inputs)
	if (locale === "es-419") return es_419_share_video_body(inputs)
	if (locale === "pt-PT") return pt_pt2_share_video_body(inputs)
	if (locale === "fr-FR") return fr_fr2_share_video_body(inputs)
	if (locale === "de-DE") return de_de2_share_video_body(inputs)
	if (locale === "it-IT") return it_it2_share_video_body(inputs)
	return en_us2_share_video_body(inputs)
});
export { share_video_body as "share.video_body" }